/**
 * @module ol/source/common
 */

/**
 * Default WMS version.
 * @type {string}
 */
export const DEFAULT_WMS_VERSION = '1.3.0';

/**
 * Number of decimal digits to consider in integer values when rounding.
 * @type {number}
 */
export const DECIMALS = 4;
